import ModalWrapper from 'components/ModalWrapper';
import styled from 'styled-components';
import Collapsible from 'components/CourseDescription/Collapsible';
import { useState } from 'react';
import PriceContainer from 'components/PriceContainer';
import { generateCoverImageUrl } from 'utils/generate_cover_image_url';
import { getClassNameByLang } from 'utils/getClassByLang';
import { getDirectionByLanguage } from 'utils/get_direction';

const CardHorizontalImg = styled.div`
  grid-column: 1/2;
  width: 100%;
  height: 13.7rem;
  border-radius: 1rem;
  background-image: url(${({ src }) => src});
  background-size: cover;
  background-position: center;
`;

const ModalCourse = (props) => {
  const courseDetail = props.data;

  const {
    courseTitle,
    language,
    courseAudience,
    courseInclusion,
    coursePackage,
    prerequisite,
    isCertificateIssued,
    price,
    discount,
    duration,
    expectedOutcomes,
    picture,
    courseOutline,
    description,
    categoryName,
    levelCourse,
    subCategoryName,
    courseOrganizer,
    facilitator,
  } = courseDetail;

  const testimonis = courseDetail.testimonials.map((row) => ({
    ...row,
    fileImage: `${process.env.API_LMS_URL}/${row.image}`,
  }));

  const coursOutlineFileName =
    courseDetail.courseOutline.outline == 'f'
      ? courseDetail.courseOutline.value.split(/[/ ]+/).pop()
      : courseDetail.courseOutline.value;
  
  const classNameByLang = getClassNameByLang(language);

  const [currentSelect, SetCurrentSelect] = useState('');
  const [customerActive, setCustomerActive] = useState(0);

  const handleCollaps = async (currentSelected) => {
    if (currentSelect == currentSelected) {
      currentSelected = '';
    }
    SetCurrentSelect(currentSelected);
  };

  return (
    <ModalWrapper {...props} isFullHeight>
      <div className="description-wrapper-modal-course pt-5">
        <div
          className="description-wrapper-modal__header position-fixed top-0 w-100 bg-white"
          style={{ borderRadius: '0.8rem', zIndex: 2 }}
        >
          <div className="content justify-content-end">
            <div className="quantity cursor-pointer text-black" onClick={() => props.setOpen(false)}>
              X
            </div>
          </div>
        </div>
        {/* left */}
        <div className="course-description mt-5 w-100" style={{ height: '85vh' }}>
          <div className="course-description__overview mt-lg-5 mt-0">
            {/* Course Image for Mobile View */}
            <CardCheckoutImage src={generateCoverImageUrl(picture)} className="d-lg-none">
              {/* <img src={ICONS.playButton} alt="icon-button" /> */}
            </CardCheckoutImage>
            <div className="title-1">{courseTitle}</div>
            {/* Course Information for Mobile View */}
            <div className="d-lg-none border-bottom mb-5">
              {/* <div className="price">
                {price["$numberDecimal"]
                  ? `${price["$numberDecimal"]} USD`
                  : price}
              </div> */}
              <PriceContainer
                variableDiscount={[discount['$numberDecimal'], discount]}
                variablePrice={[price['$numberDecimal'], price]}
                isNormal
                courseOrganizer={courseOrganizer.code}
              />
              <div className="description-checkout__details pb-3">
                <div className="informations">
                  <div className="light">Category:</div>
                  <div className="bold">{categoryName ? categoryName : '-'}</div>
                </div>
                <div className="informations">
                  <div className="light">Sub Category:</div>
                  <div className="bold">{subCategoryName ? subCategoryName : '-'}</div>
                </div>
                <div className="informations">
                  <div className="light">Course Level:</div>
                  <div className="bold">{levelCourse}</div>
                </div>
                <div className="informations">
                  <div className="light">Researcher/ Facilitator Name:</div>
                  <div dir={getDirectionByLanguage(language)} className={`bold ${classNameByLang}`}>
                    {facilitator || 'Fanny Syawbriyanti'}
                  </div>
                </div>
                <div className="informations">
                  <div className="light">Course Duration:</div>
                  {/* {isUsedTimeLimit ?  */}
                  <div className="bold">
                    {typeof duration == 'string' ? duration?.replaceAll('-', ' ') : duration?.day + ' Days'}
                  </div>

                  {/* } */}
                </div>
                <div className="informations">
                  <div className="light">Certificate Awarded:</div>
                  <div className="bold">{isCertificateIssued ? 'Badges' : 'No Certificate'}</div>
                </div>
                <div className="informations">
                  <div className="light">Language:</div>
                  <div className="bold">{language ? `${language[0].toUpperCase()}${language.slice(1)}` : ''}</div>
                </div>
              </div>
            </div>
            <div className="title-2">Description</div>
            <div
              style={{ marginBottom: '6rem' }}
              className="descriptions"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
            {courseInclusion !== ' ' && courseInclusion !== '' ? (
              <Collapsible
                title="Course Inclusions"
                description={courseInclusion}
                isOpen={'Course Inclusions' == currentSelect}
                changeModal={handleCollaps}
              />
            ) : null}
            {prerequisite !== ' ' && prerequisite !== '' ? (
              <Collapsible
                title="Prerequisite"
                description={prerequisite}
                isOpen={'Prerequisite' == currentSelect}
                changeModal={handleCollaps}
              />
            ) : null}
            {courseAudience !== ' ' && courseAudience !== '' ? (
              <Collapsible
                title="Course Audience"
                description={courseAudience}
                isOpen={'Course Audience' == currentSelect}
                changeModal={handleCollaps}
              />
            ) : null}
            {coursePackage !== ' ' && coursePackage !== '' ? (
              <Collapsible
                title="Course Packages"
                description={coursePackage}
                isOpen={'Course Packages' == currentSelect}
                changeModal={handleCollaps}
              />
            ) : null}
            {expectedOutcomes !== ' ' && expectedOutcomes !== '' ? (
              <Collapsible
                title="Expected Outcomes"
                description={expectedOutcomes}
                isOpen={'Expected Outcomes' == currentSelect}
                changeModal={handleCollaps}
              />
            ) : null}
            {courseDetail.courseOutline.value !== '' && courseDetail.courseOutline.value !== ' ' ? (
              <Collapsible
                title="Course Outline"
                isCourseOutline={courseDetail.courseOutline?.outline == 'f' ? true : false}
                url={courseDetail.courseOutline?.value}
                description={
                  courseDetail.courseOutline?.outline == 'f'
                    ? coursOutlineFileName +
                      '&emsp;' +
                      '&emsp;' +
                      '&emsp;' +
                      '&emsp;' +
                      '&emsp;' +
                      `&emsp; <a className="collapsible__download" href=${courseOutline?.value} target="_blank" rel="noreferrer">Downloads</a>`
                    : coursOutlineFileName
                }
                // description="test"
                isOpen={'Course Outline' == currentSelect}
                changeModal={handleCollaps}
                // file={}
              />
            ) : null}
            <p></p>
          </div>
          <div className="course-description__testimonial pb-5">
            <div className="customer-wrapper">
              {testimonis && testimonis.length > 0 ? (
                <>
                  <CustomerTestimonial active={customerActive}>
                    <TestimonialQuote>“</TestimonialQuote>
                    <TestimonialText>{testimonis[customerActive].review}</TestimonialText>
                  </CustomerTestimonial>
                </>
              ) : (
                ''
              )}
              {testimonis && testimonis.length > 0
                ? testimonis.map((row, index) => {
                    return (
                      <div key={`testimoni-${index + 1}`} className="customer" onClick={() => setCustomerActive(index)}>
                        <CustomerAvatar src={row.fileImage ? row.fileImage : '/dummy-avatar-img-1.png'} />
                        {/* {customerActive === 0 && ( */}
                        <div className="details">
                          <div className="bold">{row.reviewer}</div>
                          <div className="light">KPI Institute</div>
                        </div>
                        {/* )} */}
                      </div>
                    );
                  })
                : ''}
            </div>
          </div>

          {/* right */}
          {/* Course Information and Image for Desktop View */}
          <div
            className="card-floating description-checkout mt-5 d-none d-lg-block"
            style={{ top: '6rem', position: 'fixed', right: '4rem', width: '35%' }}
          >
            <CardCheckoutImage src={generateCoverImageUrl(picture)}>
              {/* <img src={ICONS.playButton} alt="icon-button" /> */}
            </CardCheckoutImage>
            <PriceContainer
              variableDiscount={[discount['$numberDecimal'], discount]}
              variablePrice={[price['$numberDecimal'], price]}
              isNormal
              courseOrganizer={courseOrganizer.code}
            />
            {/* <div className="price">
              {price["$numberDecimal"]
                ? `${price["$numberDecimal"]} USD`
                : price}
            </div> */}
            <div className="description-checkout__details">
              <div className="informations">
                <div className="light">Category:</div>
                <div className="bold">{categoryName ? categoryName : '-'}</div>
              </div>
              <div className="informations">
                <div className="light">Sub Category:</div>
                <div className="bold">{subCategoryName ? subCategoryName : '-'}</div>
              </div>
              <div className="informations">
                <div className="light">Course Level:</div>
                <div className="bold">{levelCourse}</div>
              </div>
              <div className="informations">
                <div className="light">Researcher/ Facilitator Name:</div>
                <div dir={getDirectionByLanguage(language)} className={`bold ${classNameByLang}`}>
                  {facilitator || 'Fanny Syawbriyanti'}
                </div>
              </div>
              <div className="informations">
                <div className="light">Course Duration:</div>
                {/* {isUsedTimeLimit ?  */}
                <div className="bold">
                  {typeof duration == 'string' ? duration?.replaceAll('-', ' ') : duration?.day + ' Days'}
                </div>

                {/* } */}
              </div>
              <div className="informations">
                <div className="light">Certificate Awarded:</div>
                <div className="bold">{isCertificateIssued ? 'Badges' : 'No Certificate'}</div>
              </div>
              <div className="informations">
                <div className="light">Language:</div>
                <div className="bold">{language ? `${language[0].toUpperCase()}${language.slice(1)}` : ''}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};

// Customer Testimonial
const CustomerTestimonial = styled.div`
  display: flex;
  gap: 1rem;
  position: relative;
  min-height: 23.2rem;
  width: 100%;

  margin-top: 3.2rem;
  margin-bottom: 3.6rem;

  box-shadow: 0px 3rem 4rem 0 rgba(173, 173, 173, 0.2);
  background-color: white;
  border-radius: 1rem;
  padding: 4.6rem 1.6rem 3.4rem 4.4rem;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: ${({ active = 0 }) => (active ? active * 80 : 3)}%;
    border-width: 1.5rem;
    border-style: solid;
    border-color: white transparent transparent transparent;
  }
`;
const TestimonialQuote = styled.div`
  font-weight: 800;
  font-size: 7.2rem;
  color: rgba(6, 107, 251, 1);
`;

const TestimonialText = styled.div`
  font-size: 1.8rem;
  font-weight: 400;
  color: var(--color-primary-blue-dark);
  padding-top: 2.4rem;
  line-height: 3.2rem;
`;

// Customer Avatar
const CustomerAvatar = styled.div`
  background-image: url(${({ src }) => src});
  background-position: center;
  background-size: cover;
  height: 5.6rem;
  width: 5.6rem;
  border-radius: 50%;
`;

const CardCheckoutImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  aspect-ratio: 346/180;
  // height: 23.9rem;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 14.58%, rgba(56, 56, 56, 0.54) 100%),
    url(${({ src }) => src});
  border-radius: 1.2rem;

  cursor: pointer;
  margin-bottom: 1.6rem;
`;

export default ModalCourse;
